import React from 'react';
import { useRouter } from 'hooks/use-router';
import { Button } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

export type TBackButtonProps = {};
// put this temporarily in user. can move to a more generic location later if it is shared by other components
const BackButton: React.FC<TBackButtonProps> = () => {
    const { history } = useRouter();
    return (
        <Button
            onClick={() => {
                history.goBack();
            }}
            style={{
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <ArrowBackIosIcon /> Back
        </Button>
    );
};

export default BackButton;
